import { render, staticRenderFns } from "./WidgetHead.vue?vue&type=template&id=25ecae37&scoped=true&"
import script from "./WidgetHead.vue?vue&type=script&lang=js&"
export * from "./WidgetHead.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHead.vue?vue&type=style&index=0&id=25ecae37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ecae37",
  null
  
)

export default component.exports